import { Images } from '../../../utils/images.utils';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'dp-social-network',
    templateUrl: './social-network.component.html',
    styleUrls: ['./social-network.component.scss']
})
export class SocialNetworkComponent {
    public socialLinks = [
        {
            icon: Images.FACEBOOK,
            url: 'https://www.facebook.com/serasaconsumidor'
        },
        {
            icon: Images.INSTAGRAM,
            url: 'https://instagram.com/serasaconsumidor'
        },
        {
            icon: Images.LINKEDIN,
            url: 'https://www.linkedin.com/company/serasaconsumidor'
        },
        {
            icon: Images.YOUTUBE,
            url: 'https://youtube.com/SerasaConsumidor'
        }
    ];
}
